// Per-slug default SMS bodies for ComposeSheet's SMS mode (Gap 2 §3a, decision
// §7.4: freeform body with a per-slug prefill, broker-editable, NOT a parallel
// template engine). Ad-hoc compose (no slug) starts blank.
//
// Plain text only. No em-dashes (David's hard rule). Self-contained: these are
// ad-hoc/account-level texts, so they carry no tower link; the canonical
// pilot-reminder-with-link path is the /nudge endpoint, not ComposeSheet.

export const SMS_DEFAULTS = {
  'pilot-reminder':
    'Hi {firstName}, David at NDEMNIFLY here. When you have a minute, please finish your pilot history form so I can finalize your quote. Reply here with any questions.',
  'renewal-invitation':
    'Hi {firstName}, David at NDEMNIFLY. Your aircraft insurance renewal is coming up. Reply here and I will get it started for you.',
  'renewal-nudge':
    'Hi {firstName}, David at NDEMNIFLY. Just a quick nudge on your aircraft insurance renewal. Reply here and I will pick it right up.',
  'quotes-ready':
    'Hi {firstName}, David at NDEMNIFLY. Your aircraft insurance quotes are ready. Reply here and I will walk you through them.',
};

// Resolve the default body for a slug, substituting {firstName}. Returns '' for
// an unknown/absent slug so ad-hoc SMS starts on a blank textarea.
export function smsDefaultFor(slug, ctx = {}) {
  const tpl = SMS_DEFAULTS[slug];
  if (!tpl) return '';
  return tpl.replace(/\{firstName\}/g, (ctx.firstName || 'there').trim() || 'there');
}

// GSM segment math for the char counter. SMS splits at 160 chars (single
// segment); concatenated messages cap at 1600 here per the spec's UI ceiling.
export const SMS_SINGLE_SEGMENT = 160;
export const SMS_MAX_LENGTH = 1600;

export function smsSegments(text) {
  const len = (text || '').length;
  if (len === 0) return 0;
  return Math.ceil(len / SMS_SINGLE_SEGMENT);
}
